import React, { ReactComponentElement, ReactElement, ReactNode } from 'react'
import '../ServicesComponent.scss'

interface ServiceCardProps {
    title: string
    features: string[]
    icon: ReactNode
    className?: string
}

const ServiceCard:React.FC<ServiceCardProps> = ({title, features, className, icon}) => {
    return (
        <div className={`${className} ServiceCard mb-5`}>
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        {icon}
                        <span>{title}</span>
                    </div>
                    <div className="flip-card-back">
                        <div className="features-container">
                            {features.map((feature: string) => {
                                return (
                                    <div className='feature'>
                                        <div className='circle'></div>
                                        <span>{feature}</span>
                                    </div>
                                    )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceCard